export const state = {
    widget: {},
    isLoading: false,
};

export default state;
